import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { AppShell } from '../components/layout/AppShell'
import { AdminApplications } from '../pages/admin/AdminApplications'
import { AdminAudit } from '../pages/admin/AdminAudit'
import { AdminDashboard } from '../pages/admin/AdminDashboard'
import { AdminIntegrations } from '../pages/admin/AdminIntegrations'
import { AdminProcessErrors } from '../pages/admin/AdminProcessErrors'
import { AdminProcessesToday } from '../pages/admin/AdminProcessesToday'
import { AdminRolesPermissions } from '../pages/admin/AdminRolesPermissions'
// import { AdminSettings } from '../pages/admin/AdminSettings'
import { AdminUpcomingExecutions } from '../pages/admin/AdminUpcomingExecutions'
import { AdminUsers } from '../pages/admin/AdminUsers'
import { Login } from '../pages/auth/Login'
import { Home } from '../pages/user/Home'
import { UserApplications } from '../pages/user/UserApplications'
import { UserRecentAccesses } from '../pages/user/UserRecentAccesses'
import { UserTasks } from '../pages/user/UserTasks'
import { AdminRoute } from './AdminRoute'
import { PrivateRoute } from './PrivateRoute'
import { RoleRedirect } from './RoleRedirect'
import { UserRoute } from './UserRoute'

const Router = () => (
  <Routes>
    <Route path="/login" element={<Login />} />

    <Route element={<PrivateRoute />}>
      <Route element={<AppShell />}>
        <Route element={<UserRoute />}>
          <Route path="/" element={<Home />} />
          <Route path="/aplicaciones" element={<UserApplications />} />
          <Route path="/accesos-recientes" element={<UserRecentAccesses />} />
          <Route path="/tareas" element={<UserTasks />} />
        </Route>
        <Route element={<AdminRoute />}>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/aplicaciones" element={<AdminApplications />} />
          <Route path="/admin/integraciones" element={<AdminIntegrations />} />
          <Route path="/admin/procesos-hoy" element={<AdminProcessesToday />} />
          <Route path="/admin/procesos-error" element={<AdminProcessErrors />} />
          <Route path="/admin/proximas-ejecuciones" element={<AdminUpcomingExecutions />} />
          <Route path="/admin/usuarios" element={<AdminUsers />} />
          <Route path="/admin/roles" element={<AdminRolesPermissions />} />
          {/* Configuración oculta temporalmente; conservar para su futura activación.
          <Route path="/admin/configuracion" element={<AdminSettings />} />
          */}
          <Route path="/admin/auditoria" element={<AdminAudit />} />
        </Route>
        <Route path="*" element={<RoleRedirect />} />
      </Route>
    </Route>
  </Routes>
)

export default Router
